export default "__VITE_ASSET__BvDDSqOd__"